import { useEffect, useRef } from 'react'
import { View, Text, Animated, StyleSheet } from 'react-native'
import { fonts, colors } from '../../lib/theme'
import { useTranslation } from 'react-i18next'
import { useThemeColors } from '../../lib/useThemeColors'
import { Carousel } from './ui'
import GradientButton from '../GradientButton'

// ─── PulseDot — animazione pulse identica alla PWA ────────────────────
function PulseDot() {
  const tc = useThemeColors()
  const scale  = useRef(new Animated.Value(1)).current
  const opacity = useRef(new Animated.Value(0.7)).current

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.parallel([
          Animated.timing(scale,   { toValue: 1.6, duration: 700, useNativeDriver: false }),
          Animated.timing(opacity, { toValue: 0,   duration: 700, useNativeDriver: false }),
        ]),
        Animated.parallel([
          Animated.timing(scale,   { toValue: 1, duration: 0, useNativeDriver: false }),
          Animated.timing(opacity, { toValue: 0.7, duration: 0, useNativeDriver: false }),
        ]),
      ])
    ).start()
  }, [])

  return (
    <View style={styles.dotWrap}>
      <Animated.View style={[styles.dotRing, { backgroundColor: tc.rosa, transform: [{ scale }], opacity }]} />
      <View style={[styles.dot, { backgroundColor: tc.rosa }]} />
    </View>
  )
}

export default function LiveBanner({ items, onGo }) {
  const { t } = useTranslation()
  const tc = useThemeColors()
  const styles2 = makeStyles(tc)

  if (!items || items.length === 0) return null

  return (
    <View style={{ marginBottom: 20 }}>
      <Carousel>
        {items.map((item) => (
          <View key={item.id_stage} style={styles2.banner}>
            <View style={styles2.left}>
              <PulseDot />
              <View style={{ flex: 1 }}>
                <Text style={[styles.liveLabel, { color: tc.rosaText }]}>{t('pick.live_label')}</Text>
                <Text style={[styles2.raceName, { color: tc.text }]}>
                  {item.id_type_race === 3
                    ? item.race_name
                    : `${item.race_name} — ${t('common.stage')} ${item.stage}`}
                </Text>
              </View>
            </View>
            <GradientButton onPress={() => onGo(item)} size="sm">{t('common.go')}</GradientButton>
          </View>
        ))}
      </Carousel>
    </View>
  )
}

// Stili statici (non dipendono dal tema)
const styles = StyleSheet.create({
  dotWrap:  { width: 20, height: 20, alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  dot:      { width: 10, height: 10, borderRadius: 5, position: 'absolute' },
  dotRing:  { width: 10, height: 10, borderRadius: 5, position: 'absolute' },
  liveLabel:{ fontSize: 11, fontFamily: fonts.condensedBold, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 2 },
})

// Stili tema-dipendenti
const makeStyles = (tc) => StyleSheet.create({
  banner: {
    backgroundColor: tc.rosaSubtle,
    borderWidth: 1,
    borderColor: tc.rosaGlow,
    borderRadius: 14,
    padding: 14,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  left:     { flexDirection: 'row', alignItems: 'center', gap: 10, flex: 1 },
  raceName: { fontSize: 14, fontFamily: fonts.condensedBold },
})